import { FC, ReactNode, createContext, useContext, useState } from 'react';

import { HistoryMovement } from 'types';

import { HistoryMovementsViewContextType } from '../types/HistoryMovementsViewContextType';
import { historyMovementsViewInitValue } from '../constants/historyMovementsViewInitValue';

const HistoryMovementsViewContext =
  createContext<HistoryMovementsViewContextType>(historyMovementsViewInitValue);

export const HistoryMovementsViewProvider: FC<{
  children: ReactNode;
  historyMovements: HistoryMovement[];
  operationType: string;
}> = ({ children, historyMovements, operationType }) => {
  const [expandView, setExpandView] = useState<boolean>(false);
  const [expandDirection, setExpandDirection] = useState<string>('down');

  const handleChangeExpandView = () => {
    setExpandView((prev) => !prev);
    setExpandDirection(expandView ? 'down' : 'up');
  };

  return (
    <HistoryMovementsViewContext.Provider
      value={{
        data: {
          expandView,
          expandDirection,
          historyMovements,
          operationType,
        },
        actions: {
          handleChangeExpandView,
        },
      }}
    >
      {children}
    </HistoryMovementsViewContext.Provider>
  );
};

export const useHistoryMovementsView = () => {
  const context = useContext(HistoryMovementsViewContext);
  if (!context) {
    throw new Error(
      'useHistoryMovementsView must be used within a HistoryMovementsViewProvider'
    );
  }
  return context;
};
